import { when } from '@execonline-inc/maybe-adapter';
import clsx from 'clsx';
import { observer } from 'mobx-react';
import * as React from 'react';
import Checkmark from '../Cutesies/Checkmark';
import { WizardStepItemState } from './Types';

interface Props {
  step: number;
  state: WizardStepItemState;
  children: React.ReactNode;
}

const WizardState: React.FC<Props> = ({ step, state, children }) => (
  <div
    className={clsx('flex place-content-center place-items-center', 'w-min gap-2.5')}
    data-intercom-target={`wizard-step-${step}`}
  >
    <div
      className={clsx({
        'flex place-content-center place-items-center': true,
        'h-8 w-8 rounded-full': true,
        'border border-gray-600': state === 'unstarted',
        'border-2 border-teal-600': state === 'current',
        'bg-teal-600': state === 'completed',
      })}
    >
      <div
        className={clsx({
          'flex place-content-center place-items-center': true,
          'h-6 w-6 rounded-full text-base font-semibold': true,
          'text-gray-600': state === 'unstarted',
          'bg-teal-600 text-white': state !== 'unstarted',
        })}
      >
        {when(state === 'completed', <Checkmark className="h-4 w-4 fill-white" />).getOrElse(() => (
          <p className="text-xs">{step}</p>
        ))}
      </div>
    </div>
    {children}
  </div>
);

export default observer(WizardState);
